export type PublicBookingParams = {
  ownerId: string;
  eventTypeId: string | null;
  embed: boolean;
};

/** Page client (pas le back-office pro). */
export function parsePublicBookingParams(): PublicBookingParams | null {
  if (typeof window === "undefined") return null;
  const q = new URLSearchParams(window.location.search);
  const owner = q.get("owner") || q.get("suite_user_id");
  if (!owner || !/^\d+$/.test(owner)) return null;

  const book = q.get("book") === "1" || q.get("public") === "1";
  const eventType = q.get("event_type");
  if (!book && !eventType) return null;

  return {
    ownerId: owner,
    eventTypeId: eventType && eventType.length > 0 ? eventType : null,
    embed: q.get("embed") === "1" || window.self !== window.top,
  };
}

export function isPublicBookingRoute(): boolean {
  return parsePublicBookingParams() !== null;
}
